/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Studio_CtaInputs */

const en_home_studio_cta = /** @type {(inputs: Home_Studio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know Lindevo`)
};

const lv_home_studio_cta = /** @type {(inputs: Home_Studio_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iepazīt Lindevo`)
};

/**
* | output |
* | --- |
* | "Get to know Lindevo" |
*
* @param {Home_Studio_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_studio_cta = /** @type {((inputs?: Home_Studio_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Studio_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_studio_cta(inputs)
	return en_home_studio_cta(inputs)
});